import ExceptionExamInstructions from './ExceptionExamInstructions'
import IncidentReportSubmission from './IncidentReportSubmission'
import { fetchCourseTypes } from '../../actions/course'
import { getSelectedEducationPeriod } from '../../selectors/settings'
import CoordinatorLink from './CoordinatorLink'
import DasPortalLink from './DasPortalLink'
import DigitalPortfolioLink from './DigitalPortfolioLink'
import TestDayToolkitLink from './TestDayToolKitLink'

const AP_COORDINATOR_RESOURCE_LIBRARY_URL =
  'https://apcentral.collegeboard.org/about-ap/ap-coordinators/resource-library'
const AP_COORDINATOR_EXPERIENCE_URL =
  'https://apcentral.collegeboard.org/professional-learning/learning-opportunities-ap-coordinators'

const mapStateToProps = state => {
  const {
    user: {
      data: { selectedOrgId },
    },
    availableCourseTypes: { hasAP, hasPreAP },
  } = state

  return {
    educationPeriodCd: getSelectedEducationPeriod(state),
    orgId: selectedOrgId,
    hasAP,
    hasPreAP,
  }
}

const CoordinatorDashboard = ({
  isCSR,
  educationPeriodCd,
  orgId,
  hasAP = false,
  hasPreAP = false,
  fetchCourseTypes,
}) => {
  let title = ''
  const titles = []
  if (hasAP) {
    titles.push('AP')
  }
  if (hasPreAP) {
    titles.push('Pre-AP')
  }
  title = titles.join(' & ')

  useEffect(() => {
    if (orgId && educationPeriodCd) {
      fetchCourseTypes(orgId, educationPeriodCd)
    }
  }, [orgId, educationPeriodCd])

  return (
    <div className="container">
      <TestDayToolkitLink description="Administer fully digital and hybrid AP Exams using Bluebook." />
      <DigitalPortfolioLink description="Monitor student submission and teacher scoring for the Digital Portfolio:  AP African American Studies, AP Art and Design, AP Capstone, and AP Computer Science Principles and AP Latin Exams.  Download the Personalized Project Reference (PPR) for the AP Computer Science Principles Exam." />
      <DasPortalLink description="Upload and submit recorded audio responses to the AP Program for the AP French, German, Italian, and Spanish Language and Culture Exams, and the AP Music Theory Exam." />
      <CoordinatorLink
        linkName="AP Coordinator Experience"
        disabled={isCSR}
        linkUrl={AP_COORDINATOR_EXPERIENCE_URL}
        description="View the latest training, professional development, and resources for AP coordinators."
      />
      <CoordinatorLink
        linkName="AP Coordinator Resource Library"
        disabled={isCSR}
        linkUrl={AP_COORDINATOR_RESOURCE_LIBRARY_URL}
        description="Access resources for AP coordinators throughout the school year, including the AP Coordinators Manual, resources for setup, enrollment, and ordering, and exam day resources."
      />
      <CoordinatorLink
        linkName={`${title} Classroom`}
        disabled={isCSR}
        linkUrl={Config.FINE_TUNE_URL}
        description="Access AP coordinator interactive tutorials and AP resources for your teachers and students"
      />
      <ExceptionExamInstructions />
      <IncidentReportSubmission />
      <CoordinatorLink
        linkName="Return to AP Central"
        disabled={isCSR}
        linkUrl={Config.MYAP_URL.prof}
        newWindow={false}
      />
    </div>
  )
}

export default connect(mapStateToProps, { fetchCourseTypes })(CoordinatorDashboard)
